export default function SiteMaintenance() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">
        Сайт түр хаагдсан
      </h1>

    </div>
  );
}